import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Modal,
  Pagination,
  Popconfirm,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  TableColumnsType,
  Tabs,
  Typography,
} from "antd";
import { allowedDomainsAll, UserType } from "~/Utils";
import { Icon } from "@iconify/react";
import { ContentWrapper, DataTable } from "~/Components";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import { useHasAccess } from "@hooks/useHasAccess";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@hooks/useAuth";
import { useQuery } from "@hooks/useQuery";
import { getFormattedDate, getKey, switchHasRole } from "@utils/CommonUtils";
import { get, post, put } from "~/Services";
import { useNotification } from "@hooks/useNotification";
import { ErrorMessage, Field, FieldProps, Formik } from "formik";
import TextArea from "antd/es/input/TextArea";
import * as yup from "yup";
import styles from "@modules/ContractManagement/Contract.module.scss";
import { strings } from "@utils/Strings";
import { debounce, isBoolean, values, startCase, toLower } from "lodash";
import { SuccessModal } from "@components/SuccessModal/SuccessModal";
import { useLocalStorage } from "@hooks/useLocalStorage";

const initialValue = {
  rejectionReason: "",
};

interface FormItems {
  division: string;
  LOA_Creator: boolean;
  LOA_Reviewer: boolean;
  Contract_Creator: boolean;
  Contract_Reviewer: boolean;
  Management_Dashboard: boolean;
  PCD_Admin: boolean;
  userName: string;
  userEmail: string;
  role: string | null;
}

const defaultValue = {
  division: "",
  LOA_Creator: false,
  LOA_Reviewer: false,
  Contract_Creator: false,
  Contract_Reviewer: false,
  Management_Dashboard: false,
  PCD_Admin: false,
  userName: "",
  userEmail: "",
  role: "",
} as FormItems;

export const UserManagement = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { hasRole } = useHasAccess();
  const { openToast } = useNotification();
  const [data, setData] = useState<any>([]);
  const [modal, setModal] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(10);
  const [isLoading, setIsLoading] = useState(false);
  const [switchLoading, setSwitchLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [commentLoading, setCommentLoading] = useState(false);
  const [rejectRecord, setRejectRecord] = useState<any>();
  const [refetch, setRefetch] = useState(false);
  const [page, setpage] = useState<number>(0);
  const [sortOrder, setSortOrder] = useState("desc");
  const [orderByName, setOrderByName] = useState("updatedOn");
  const [pageStart, setPageStart] = useState<number>(0);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [clearSearch, setClearSearch] = useState(false);
  const [apiUrl, setApiUrl] = useState<any>("");
  const [searchString, setSearchString] = useState("");
  const [loading, setLoading] = useState(false);
  const [successLoader, setSuccessLoader] = useState(false);
  const [defUser, setDefUser] = useLocalStorage("user", null);
  const [divisionModal, setDivisionModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>();
  const [modalRecord, setModalRecord] = useState([]);
  const [modalValue, setModalValue] = useState();
  const query = useQuery();

  const validationSchema1 = yup.object().shape({
    division: yup.string().strict(true).required("Division is required"),
  });

  const onSubmitModal = async (values: any) => {
    setLoading(true);
    const payload = {
      status: "active",
      requestRoles: [values.role],
    };
    post(`/v1/user/onboarded/add-user`, payload)
      .then((res) => {
        setSuccessLoader(true);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const onSubmit = async (values: any, formikHelpers: any) => {
    const roles = [];
    for (const [key, value] of Object.entries(values)) {
      if (value && isBoolean(value)) {
        roles.push(key);
      }
    }
    if (roles.length == 0) {
      message.info("Atleast a single role must be requested for onboarding request");
      return;
    }
    const payload = {
      uniqueId: selectedRecord.uniqueId,
      division: values.division,
      newRoles: roles,
    };
    setLoading(true);
    put(`user/onboarded/update-division-roles`, payload)
      .then((res) => {
        setDefUser({ ...defUser, isRequestedStatus: true, status: "pending" });
        setSuccessLoader(true);
        setLoading(false);
        setRefetch((prevState) => !prevState);
        formikHelpers.resetForm();
        setDivisionModal(false);
      })
      .catch((err) => {
        setLoading(false);
        setDivisionModal(false);
        formikHelpers.resetForm();
        setRefetch((prevState) => !prevState);
      });
  };

  const updateRole = (record?: any, role?: any, isActive?: boolean, isOnboarded?: boolean, changeRole?: boolean) => {
    // if (record.roles.length == 1 && record.roles[0]) {
    //   openToast({
    //     content: "User with no role is not possible. Please select another role before removing the last one.",
    //     type: "info",
    //   });
    //   return;
    // }
    setSwitchLoading(true);
    let payload;
    if (selectedRowId !== null) {
      payload = {
        uniqueId: selectedRowId,
        newRoles: role ? [role] : [],
      };
    } else if (role == "SPA_ADMIN") {
      payload = {
        uniqueId: record?.uniqueId,
        newRoles: isActive ? ["SPA_ADMIN"] : [],
      };
    } else if (role == "SPA_APPROVER") {
      payload = {
        uniqueId: record?.uniqueId,
        newRoles: isActive ? ["SPA_APPROVER"] : [],
      };
    }
    put(`v1/user/${isOnboarded ? "onboarded" : "onboarded"}/update-roles`, payload)
      .then((res: any) => {
        setRefetch((prevState: boolean) => !prevState);
        setSwitchLoading(false);
        setSelectedRowId(null);
        setLoading(false);
      })
      .catch((err) => {
        message.error(err);
        setSwitchLoading(false);
        setLoading(false);
      });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setClearSearch(false);
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [isLoading]);


  const updateActiveRole = (record: any, activate: boolean) => {
    setButtonLoading(true);
    const formData = new FormData();
    formData.append("uniqueId", record.uniqueId);
    post(`${activate ? "v1/user/onboarded/user-activate" : "v1/user/onboarded/user-de-activate"}`, formData)
      .then((res: any) => {
        setButtonLoading(false);
        setRefetch((prevState: boolean) => !prevState);
      })
      .catch((err: any) => {
        setButtonLoading(false);
        message.error(err);
      });
  };


  const tableRef = useRef<any>(null);

  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: 'smooth', block: "start" });
    }
  }, [page]);


  const approveNewRole = (record: any) => {
    setButtonLoading(true);
    const payload = {
      uniqueId: record.uniqueId,
      approved_roles: [...record.roles],
    };
    post(`user/onboarding/approve`, payload)
      .then((res: any) => {
        setButtonLoading(false);
        setRefetch((prevState: boolean) => !prevState);
      })
      .catch((err: any) => {
        setButtonLoading(false);
        message.error(err);
      });
  };

  const handleChangeRole = (record: any, value: any) => {
    setSelectedRowId(record.uniqueId);
    setModalRecord(record);
    setModalValue(value);
  };

  const handleModalClose = () => {
    setSelectedRowId(null);
  };

  const validationSchemaModal = yup.object().shape({
    role: yup.string().nullable().required("Role is required"),
  });

  const activeUserColumn: TableColumnsType = [
    {
      title: "User Name",
      dataIndex: "name",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "name"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "name"
          ? "descend"
          : undefined,
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: (
        <span>
          SPA Approver
          <Popover
            overlayInnerStyle={{ maxWidth: 450, width: 450 }}
            placement="topLeft"
            content={<p>{strings.approverInfo}</p>}
          >
            <Icon
              icon="bi:info-circle"
              style={{ color: styles.strawberry, marginLeft: 5 }}
            />
          </Popover>
        </span>
      ),
      dataIndex: "user",
      render: (value: any, record: any) =>
        (
          <Switch
            disabled={switchHasRole(record, "SPA_ADMIN")}
            checked={switchHasRole(record, "SPA_APPROVER")}
            onChange={(value) => updateRole(record, "SPA_APPROVER", value, true, false)}
          />
        ) || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: (
        <span>
          SPA Admin
          <Popover
            overlayInnerStyle={{ maxWidth: 450, width: 450 }}
            placement="topLeft"
            content={<p>{strings.spaAdmin}</p>}
          >
            <Icon
              icon="bi:info-circle"
              style={{ color: styles.strawberry, marginLeft: 5 }}
            />
          </Popover>
        </span>
      ),
      dataIndex: "roles",
      render: (value: any, record: any) =>
        (
          <Switch
            disabled={switchHasRole(record, "SPA_APPROVER")}
            checked={switchHasRole(record, "SPA_ADMIN")}
            onChange={(value) => updateRole(record, "SPA_ADMIN", value, true, false)}
          />
        ) || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: "Updated At",
      dataIndex: "updatedOn",
      render: (value: any, record: any) => getFormattedDate(value) || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: "Updated By",
      dataIndex: "updatedBy",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },

    {
      title: "Action",
      dataIndex: "user",
      render: (value: any, record: any) => {
        return (
          <>
            <div style={{ display: "flex", gap: 8 }}>
              <Popconfirm
                title={"Are you sure to Deactivate the user?"}
                placement="topLeft"
                onConfirm={() => updateActiveRole(record, false)}
                okText={"Yes"}
                cancelText={"Cancel"}
              >
                <Button
                  title="Deactivate"
                  danger={true}
                >
                  <Icon
                    fontSize={26}
                    icon="mdi:user-block-outline"
                  />
                </Button>
              </Popconfirm>
              <Button
                title="Change Role"
                onClick={() => handleChangeRole(record, value)}
              >
                <Icon
                  fontSize={28}
                  icon="fluent:person-swap-20-filled"
                />
              </Button>
            </div>
          </>
        );
      },
    },
  ];

  const deactiveUserColumn: TableColumnsType = [
    {
      title: "User Name",
      dataIndex: "name",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "name"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "name"
          ? "descend"
          : undefined,
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: (
        <span>
          SPA Approver
          <Popover
            overlayInnerStyle={{ maxWidth: 450, width: 450 }}
            placement="topLeft"
            content={<p>{strings.approverInfo}</p>}
          >
            <Icon
              icon="bi:info-circle"
              style={{ color: styles.strawberry, marginLeft: 5 }}
            />
          </Popover>
        </span>
      ),
      dataIndex: "user",
      render: (value: any, record: any) =>
        (
          <Switch
            disabled={true}
            checked={switchHasRole(record, "SPA_APPROVER")}
            onChange={(value) => updateRole(record, "SPA_APPROVER", value, false, false)}
          />
        ) || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: (
        <span>
          SPA Admin
          <Popover
            overlayInnerStyle={{ maxWidth: 450, width: 450 }}
            placement="topLeft"
            content={<p>{strings.spaAdmin}</p>}
          >
            <Icon
              icon="bi:info-circle"
              style={{ color: styles.strawberry, marginLeft: 5 }}
            />
          </Popover>
        </span>
      ),
      dataIndex: "user",
      render: (value: any, record: any) =>
        (
          <div>
            <Switch
              disabled={true}
              checked={switchHasRole(record, "SPA_ADMIN")}
              onChange={(value) => updateRole(record, "SPA_ADMIN", value, false, false)}
            />
          </div>
        ) || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: "Deactivated At",
      dataIndex: "deactivatedOn",
      render: (value: any, record: any) => getFormattedDate(value) || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: "Deactivated By",
      dataIndex: "deactivatedBy",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: "Action",
      dataIndex: "user",
      render: (value: any, record: any) =>
        (
          <Popconfirm
            title={"Are you sure to Reactivate the user"}
            okText={"Yes"}
            cancelText={"Cancel"}
            onConfirm={() => updateActiveRole(record, true)}
          >
            <Button>Reactivate</Button>
          </Popconfirm>
        ) || <Typography.Text disabled>-</Typography.Text>,
    },
  ];

  const handleTableSort = (column: any, sortOrder: string, page: any) => {
    let order = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    getRecords(order, column.dataIndex, searchString, pageStart);
  };

  useEffect(() => {
    getRecords(sortOrder, orderByName, searchString, searchString.length > 0 ? 0 : pageStart);
  }, [query, refetch, pageStart, searchString]);

  const handleSearchChange = debounce((value: string, isLoading: boolean) => {
    setSearchString(value);
    setIsLoading(isLoading);
  }, 1000);

  const getRecords = (sortOrder: string, orderByParam: string, searchString: any, currentPage?: number) => {
    setIsLoading(true);
    let url = `user/onboarded/get/user-list`;
    if (query.get("activeTab") === "activeUsers") {
      url = `v1/user/onboarded/get/user-list?isActive=true&page=${currentPage}&size=${recordsPerPage}&order=${sortOrder}&orderBy=${orderByParam}&searchText=${encodeURIComponent(searchString)}&createdThrough=Portal`;
    } else if (query.get("activeTab") === "deactivatedUsers") {
      url = `v1/user/onboarded/get/user-list?isActive=false&page=${currentPage}&size=${recordsPerPage}&order=${sortOrder}&orderBy=${orderByParam}&searchText=${encodeURIComponent(searchString)}&createdThrough=Portal`;
    }
    setApiUrl(url);
    get(url)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          setTotalRecords(res.response.data.totalCount);
          let envelopes = res.response.data.records;
          setData(envelopes);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setData([]);
        message.error(err);
        setIsLoading(false);
      });
  };

  const items = [
    {
      label: "Active Users",
      key: "activeUsers",
      children: (
        <>
        <div ref={tableRef}>
          <DataTable
            columns={activeUserColumn?.map((column) => ({
              ...column,
              onHeaderCell: (column:any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder, page ? page : 0);
                  }
                },
              }),
            }))}
            tableData={
              data
                ? data.map((d:any, index:any) => ({
                    ...d,
                    key: getKey(page, index),
                    // createdOn: d.createdOn,
                    // updatedOn: d.updatedOn,
                  }))
                : null
            }
            className="table-clickable"
            searchPlaceholderText={"Search"}
            hideExport={false}
            inputDisable={isLoading}
            exportFileName="Active_Users"
            totalRecords={totalRecords}
            isServerSearchApi={true}
            exportApiUrl={apiUrl}
            recordsPerPage={recordsPerPage}
            clearStringSearch={clearSearch}
            onSearchChange={handleSearchChange}
            multiSelect={true}
            ctaColSpan={17}
            isPagination={true}
            excludeExportCols={["Updated At", "Updated By", "Action"]}
            includeExportCols={[
              {
                displayName: "Current Role",
                dataIndex: "currentRole",
                render: (value:any) => startCase(toLower(value)),
              },
              {
                displayName: "Updated At",
                dataIndex: "updatedOn",
                render: (value:any, record:any) =>
                  getFormattedDate(value) || <Typography.Text disabled>-</Typography.Text>,
              },
              {
                displayName: "Updated By",
                dataIndex: "updatedBy",
                render: (value:any) => value,
              },
            ]}
            tabOffset={60}
          />
        </div>
        <div className="pagination">
          <Pagination
            defaultCurrent={1}
            current={page + 1}
            total={totalRecords}
            onChange={(newPage) => {
              const pageSize = 10;
              const startIndex = newPage - 1;
              setpage(newPage - 1);
              setPageStart(startIndex);
              getRecords(sortOrder, orderByName, searchString, startIndex);
            }}
            showSizeChanger={false}
          />
        </div>
      </>
      ),
    },
    {
      label: "Deactivated Users",
      key: "deactivatedUsers",
      children: (
        <>
        <div ref={tableRef}>
          <DataTable
            columns={deactiveUserColumn?.map((column:any) => ({
              ...column,
              onHeaderCell: (column:any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder, page ? page : 0);
                  }
                },
              }),
            }))}
            tableData={
              data
                ? data.map((d:any, index:any) => ({
                    ...d,
                    key: getKey(page, index),
                    // createdOn: d.createdOn,
                    // updatedOn: d.updatedOn,
                  }))
                : null
            }
            className="table-clickable"
            searchPlaceholderText={"Search"}
            isServerSearchApi={true}
            hideExport={false}
            exportApiUrl={apiUrl}
            totalRecords={totalRecords}
            exportFileName="Deactivated_Users"
            onSearchChange={handleSearchChange}
            recordsPerPage={recordsPerPage}
            clearStringSearch={clearSearch}
            multiSelect={true}
            isPagination={true}
            ctaColSpan={17}
            excludeExportCols={["Deactivated At", "Deactivated By", "Action"]}
            includeExportCols={[
              {
                displayName: "Current Role",
                dataIndex: "currentRole",
                render: (value:any) => startCase(toLower(value)),
              },
              {
                displayName: "Deactivated At",
                dataIndex: "deactivatedOn",
                render: (value:any, record:any) =>
                  getFormattedDate(value) || <Typography.Text disabled>-</Typography.Text>,
              },
              {
                displayName: "Deactivated By",
                dataIndex: "deactivatedBy",
                render: (value:any) => value,
              },
            ]}
            tabOffset={60}
          />
        </div>
        <div className="pagination">
          <Pagination
            defaultCurrent={1}
            current={page + 1}
            total={totalRecords}
            onChange={(newPage) => {
              const pageSize = 10;
              const startIndex = newPage - 1;
              setpage(newPage - 1);
              setPageStart(startIndex);
              getRecords(sortOrder, orderByName, searchString, startIndex);
            }}
            showSizeChanger={false}
          />
        </div>
      </>
      ),
    },
  ];

  const validationSchema = yup.object().shape({
    rejectionReason: yup.string().required("Reject Reason is required field"),
  });

  useEffect(() => {
    if (!query.get("activeTab")) {
      if (hasRole(["SUPER_ADMIN"])) {
        navigate(`/user-management?activeTab=activeUsers`, {
          replace: true,
        });
      } else {
        navigate(`/user-management?activeTab=activeUsers`, {
          replace: true,
        });
      }
    }
  }, []);

  return (
    <ContentWrapper
      title={" User Management"}
      actionItems={
        hasRole(["*"]) && (
          <Button
            type="primary"
            onClick={() => navigate(`/user-management/add`)}
          >
            <Space>
              <Icon
                icon="akar-icons:plus"
                inline
              />
              Add
            </Space>
          </Button>
        )
      }
    >
      {(buttonLoading || switchLoading || isLoading) && (
        <div className="loadingOverlay">
          <Space size="middle">
            <Spin size="large" />
          </Space>
        </div>
      )}
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          setSearchString("")
            setClearSearch(true)
          setPageStart(0);
          setpage(0);
          if (hasRole(["SUPER_ADMIN"])) {
            navigate(`/user-management?activeTab=${activeKey}`);
          } else {
            navigate(`/user-management?activeTab=${activeKey}`);
          }
        }}
      ></Tabs>
      <Formik
        onSubmit={(values, formikHelpers) => {
          setCommentLoading(true);
          const payload = {
            uniqueId: rejectRecord.uniqueId,
            rejectionReason: values.rejectionReason,
          };
          post(`/user/onboarding/reject`, payload)
            .then((res: any) => {
              setCommentLoading(false);
              setModal(false);
              setRefetch((prevState: boolean) => !prevState);
            })
            .catch((err: any) => {
              setCommentLoading(false);
              message.error(err);
            });
        }}
        initialValues={initialValue}
        validationSchema={validationSchema}
      >
        {({ submitForm, resetForm, setFieldValue, touched, errors, isValid, dirty, values }) => (
          <Modal
            title={"Rejection Reason"}
            maskClosable={false}
            open={modal}
            onOk={() => {
              submitForm();
            }}
            okButtonProps={{ disabled: !(isValid && dirty) }}
            onCancel={() => {
              setModal(false);
              resetForm();
            }}
            confirmLoading={commentLoading}
            okText={"Reject"}
            width={600}
            centered
          >
            <Form
              layout="vertical"
              onFinish={submitForm}
            >
              <Field name={"rejectionReason"}>
                {({ field, meta }: FieldProps) => {
                  return (
                    <Form.Item
                      label={"Please comment rejection reason"}
                      validateStatus={meta.touched && meta.error ? "error" : ""}
                    >
                      <TextArea
                        rows={4}
                        maxLength={5000}
                        showCount
                        {...field}
                      />
                      {meta.touched && meta.error && (
                        <Typography.Text type="danger">{meta.error.toString()}</Typography.Text>
                      )}
                    </Form.Item>
                  );
                }}
              </Field>
            </Form>
          </Modal>
        )}
      </Formik>
      <Formik
        initialValues={defaultValue}
        onSubmit={(values, formikHelpers) => onSubmit(values, formikHelpers)}
        validationSchema={validationSchema1}
      >
        {(props) => {
          return (
            <Modal
              title={
                <Typography.Title
                  level={4}
                  style={{ marginBottom: 10 }}
                >
                  User Division Change
                </Typography.Title>
              }
              open={divisionModal}
              width={500}
              onCancel={() => {
                props.resetForm();
                setDivisionModal(false);
              }}
              okText={"Submit"}
              footer={null}
            >
              <Form
                layout="vertical"
                onFinish={props.handleSubmit}
              >
                <Row style={{ display: "block", width: "100%" }}>
                  <Col
                    xs={24}
                    md={16}
                  >
                    {
                      <>
                        <Row gutter={16}>
                          <Col
                            md={24}
                            sm={24}
                          >
                            <Form.Item label={"Select Division"}>
                              <Field name={`division`}>
                                {({ field }: FieldProps) => (
                                  <Select
                                    showSearch
                                    value={field.value}
                                    filterOption={(input, option: any) =>
                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    onChange={(e) => {
                                      props.setFieldValue("division", e);
                                    }}
                                    onBlur={() => props.setFieldTouched("division", true)}
                                    status={(props.touched.division && props.errors.division && "error") || ""}
                                  >
                                    <Select.Option
                                      value={"PCD"}
                                      key={"PCD"}
                                    >
                                      {"PCD"}
                                    </Select.Option>
                                    <Select.Option
                                      value={"COMMERCIAL"}
                                      key={"COMMERCIAL"}
                                    >
                                      {"COMMERCIAL"}
                                    </Select.Option>
                                    <Select.Option
                                      value={"LEGAL"}
                                      key={"LEGAL"}
                                    >
                                      {"LEGAL"}
                                    </Select.Option>
                                  </Select>
                                )}
                              </Field>
                              <Typography.Text type="danger">
                                <ErrorMessage name={`division`} />
                              </Typography.Text>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col
                    xs={16}
                    md={24}
                    sm={24}
                    style={{ textAlign: "right" }}
                  >
                    <Space>
                      <Button
                        htmlType="submit"
                        type="primary"
                        loading={loading}
                      >
                        Submit
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form>
            </Modal>
          );
        }}
      </Formik>
      <SuccessModal
        redirect={"/user-management?activeTab=activeUsers"}
        title={"Successfully Requested Access"}
        message={"You have successfully requested access for SPA"}
        type={"success"}
        buttonText={"Go Back"}
        open={successLoader}
        setOpen={setSuccessLoader}
      />
      <Modal
        open={!!selectedRowId}
        onCancel={handleModalClose}
        footer={null}
      >
        <Formik
          initialValues={{ role: "" }}
          onSubmit={(values) => {
            setLoading(true);
            updateRole(modalRecord, values.role, modalValue, false, true);
          }}
          validationSchema={validationSchemaModal}
        >
          {(props) => (
            <Form
              layout="vertical"
              onFinish={props.handleSubmit}
            >
              <Row style={{ marginTop: 16, display: "block", width: "100%" }}>
                <Col
                  xs={24}
                  md={16}
                >
                  <Row gutter={16}>
                    <Col md={24}>
                      <Typography.Title
                        level={5}
                        style={{ marginBottom: 10 }}
                      >
                        Choose the access you want
                      </Typography.Title>
                    </Col>
                    <Col md={24}>
                      <Form.Item
                        name="role"
                        initialValue=""
                      >
                        <Field name="role">
                          {({ field }: FieldProps) => (
                            <Radio.Group {...field}>
                              <Radio value="SPA_APPROVER">SPA Approver</Radio>
                              <Radio value="SPA_ADMIN">SPA Admin</Radio>
                            </Radio.Group>
                          )}
                        </Field>
                      </Form.Item>
                      <Typography.Text type="danger">
                        <ErrorMessage name="role" />
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div style={{ textAlign: "right" }}>
                <Space>
                  <Button
                    htmlType="submit"
                    type="primary"
                    loading={loading}
                  >
                    Submit
                  </Button>
                </Space>
              </div>
            </Form>
          )}
        </Formik>
        <SuccessModal
          redirect={-1}
          title="Successfully Created User"
          message="You have successfully created a new user"
          type="success"
          buttonText="Go Back"
          open={successLoader}
          setOpen={setSuccessLoader}
        />
      </Modal>
    </ContentWrapper>
  );
};
